import React, { useState } from "react";
import "../../../components/table/table.css";
import { FaFileAlt, FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import toTitleCase from "../../../lib/titleCase/TitleCase";
import DateConvertor from "../../../components/dateConvertor/DateConvertor";
import StatusBadge from "./StatusBadge";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import TruncateWord from "../../../lib/truncateWords/TruncateWord";

const LeaveTable = ({ last_ten_leave }) => {
  const user_info = useSelector((state) => state.authentication.userdetails);

  const [showTable, setShowTable] = useState(true);
  const navigate = useNavigate();

  const handleClick = () => {
    if (
      user_info?.is_superuser ||
      user_info.invitation_type === "ORGANIZATION" ||
      user_info.emp_department.some((item) => item.name === "HR")
    ) {
      navigate("/hrleave/Hrleave");
    } else {
      navigate("/ems/leave");
    }
  };

  return (
    <div className="leave-wrapper">
      <div className="leave-header">
        <div className="leave-title">
          <FaFileAlt className="leave-icon" />
          <span>Last 10 Leaves Requests</span>
        </div>
        <div className="leave-actions">
          <button className="view-all-btn" onClick={handleClick}>
            View All
          </button>
          <button
            className="icon-toggle-btn"
            onClick={() => setShowTable(!showTable)}
          >
            {showTable ? <FaMinusCircle /> : <FaPlusCircle />}
          </button>
        </div>
      </div>

      {showTable && (
        <div className="table-container">
          <table className="leave-table">
            <thead>
              <tr>
                <th className="pl-3">Employee</th>
                <th>Type</th>
                <th>From</th>
                <th>To</th>
                <th>Days</th>
                <th>Types</th>
                <th>Reason</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {last_ten_leave?.map((request) => (
                <tr key={request.id}>
                  <td className="pl-3 text-nowrap">
                    {toTitleCase(request.created_by__firstname)}{" "}
                    {toTitleCase(request.created_by__lastname)}
                  </td>
                  <td>{toTitleCase(request.leave_category)}</td>
                  <td className="pl-3 text-nowrap">
                    <DateConvertor inputDate={request.from_date} />{" "}
                  </td>
                  <td className="pl-3 text-nowrap">
                    <DateConvertor inputDate={request.to_date} />
                  </td>
                  <td>{request.days}</td>
                  <td>{toTitleCase(request.leave_apply_type)}</td>
                  <td className="text-truncate" style={{ maxWidth: "150px" }}>
                    {
                      <TruncateWord
                        strng={toTitleCase(request.remarks)}
                        charLimit={10}
                      />
                    }
                  </td>
                  <td className="text-nowrap">
                    <StatusBadge
                      status={toTitleCase(request.cm_current_status)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default LeaveTable;
